<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 10C22 16.6274 16.6274 22 10 22H2V14C2 7.37258 7.37258 2 14 2H22V10ZM17.5488 8.03906C17.2025 7.73627 16.6751 7.7719 16.3721 8.11816L11.125 14.1133L7.58887 10.5771C7.26351 10.2521 6.73651 10.2521 6.41113 10.5771C6.08571 10.9026 6.0857 11.4304 6.41113 11.7559L10.5771 15.9229C10.7402 16.0858 10.9639 16.1737 11.1943 16.166C11.4248 16.1583 11.6421 16.0553 11.7939 15.8818L17.627 9.21484C17.9297 8.86854 17.8949 8.34207 17.5488 8.03906Z"
      fill="currentColor"
    />
  </svg>
</template>
